import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
function FounderMessage() {
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">Founder’s Message</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> Founder’s Message</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Founder’s Message</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 PrincipalDesk principal-message">
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/images/founder.jpg" alt="Principal Photo" className="img-fluid" />
                            <p>

                                His Grace Dr. Stephanos Mar Theodosius of Blessed Memory<br />

                                Former Metropolitan of the Diocese of Kolkata<br />

                                God chooses great leaders to lead his people and to be good stewards in His kingdom. His Grace Dr. Stephanos Mar Theodosius, the former Bishop of Kolkata Diocese of the Indian Orthodox Church, was one such visionary leader. He was born on 2 October1924 in Pathamoothom, Kottayam, Kerala and was named Punnose by his parents.<br />

                                After his ordination, Fr. Punnose, started his services as Parish Priest in Jabalpur, Madhya Pradesh in the year 1952. He was appointed as the Director of the newly founded St. Thomas Orthodox Church Mission at Bhilai in 1972. Driven with a burning zeal to serve the downtrodden, he whole-heartedly accepted the post.<br />

                                In 1975, Fr. Punnose was consecrated as Bishop Stephanos Mar Theodosios. He became the first Bishop of the Diocese of Madras and later, in 1979, when the Diocese of Kolkata was formed, he became its first Bishop.<br />

                                The activities of St. Thomas Mission became more extensive and increased rapidly under His Graces’ vision and guidance. Educational institutions, health service centers, village development centers, balagrams (Children’s homes), rehabilitation centers, ashrams and convents were successfully established in the states from Madhya Pradesh to Nagaland.<br />

                                His Grace’s dedicated service, persistent hard work and love for education produced a good number of educational institutions across his pastoral domain. More than two dozen schools and colleges as well as a number of balwadis were established in Central and Eastern India, with the aim of uplifting and providing the best education especially to the underprivileged sections of the society. Health service centres, village development centres, balagrams (Children’s homes), rehabilitation centres, were successfully established for the needy.<br />

                                His Grace, whose missionary zeal and vision contributed phenomenally to the fields of education and health sectors in general and the upliftment of the marginalized and tribals in particular, was a much acclaimed and respected personality in religious, lay, private, public and government circles. Though His Grace left for his heavenly abode on 5 November 2007, his valuable and innumerable contributions remain as a glorious legacy of this great visionary and Man of God.
                            </p>
                            <p><b>Dr. Stephanos Mar Theodosius<br />
                                Founder </b></p>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default FounderMessage